export const DEFAULT_NODE_POSITION = { x: 0, y: 0 };

export const ROUTER_CONNECTION_LIMITS = {
  decideIfCouponsForTypeExist: 2,
  decideByWorkingHours: 2,
  decideByRecentLLMQuestionThreshold: 2,
  default: 99,
};
